<template>
    <div class="employer-confidential-files" v-if="canSeeConfidentialFiles">

        <!-- Header -->
        <div class="c-common-space c-responsive-fixwidth">
            <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                    <div class="clearfix o-employer-a">
                        <h3>Confidential Files</h3>
                        <ul class="o-filter-area" style="margin-bottom: 15px;">
                            <li>
                                <a href="javascript: void(0)" @click="showAddNote = true" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green">
                                    <i class="fa fa-plus" aria-hidden="true"></i> Add Note
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="showUploadForm = true" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange">
                                    <i class="fa fa-upload" aria-hidden="true"></i> Upload File
                                </a>
                            </li>
                        </ul>

                        <!-- Add Note Inline Form -->
                        <div v-if="showAddNote" class="c-common-box-shadow c-radius3" style="padding: 15px; margin-bottom: 15px; background: #fafafa;">
                            <p><strong>Add Confidential Note</strong></p>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="common-label-text">Name:</label>
                                        <input type="text" class="form-control" placeholder="Note title" v-model="newNote.name">
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text">Content:</label>
                                        <textarea class="form-control" rows="4" placeholder="Type your confidential note" v-model="newNote.content"></textarea>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <ul class="o-filter-area">
                                        <li>
                                            <a href="javascript: void(0)" @click="cancelAddNote()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue">
                                                <i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" @click="saveNote()" class="c-solid-btn c-solid-btn--small c-solid-btn--green">
                                                <i class="fa fa-floppy-o" aria-hidden="true"></i> Save
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Upload File Inline Form -->
                        <div v-if="showUploadForm" class="c-common-box-shadow c-radius3" style="padding: 15px; margin-bottom: 15px; background: #fafafa;">
                            <p><strong>Upload Confidential File</strong></p>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="common-label-text">File Type:</label>
                                        <select class="form-control" v-model="uploadFileType">
                                            <option value="document">Document</option>
                                            <option value="audio">Audio</option>
                                            <option value="video">Video</option>
                                            <option value="photo">Photo</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-8">
                                    <div class="form-group">
                                        <label class="common-label-text">Select File:</label>
                                        <input type="file" class="form-control" ref="fileInput" @change="onFileSelected($event)">
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <ul class="o-filter-area">
                                        <li>
                                            <a href="javascript: void(0)" @click="cancelUpload()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue">
                                                <i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel
                                            </a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" @click="uploadFile()" class="c-solid-btn c-solid-btn--small c-solid-btn--green" :class="{ 'isDisabled': !selectedFile }">
                                                <i class="fa fa-upload" aria-hidden="true"></i> Upload
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Loading State -->
                        <div v-if="loading" class="text-center" style="padding: 30px;">
                            <i class="fa fa-spinner fa-spin fa-2x"></i>
                            <p>Loading confidential files...</p>
                        </div>

                        <!-- Empty State -->
                        <div v-if="!loading && files.length === 0" class="o-file-strip c-common-box-shadow">
                            No confidential files found
                        </div>

                        <!-- File Cards -->
                        <div v-if="!loading && files.length > 0" class="row">
                            <div class="col-sm-6 col-md-4" v-for="file in files" :key="file.id" style="margin-bottom: 15px;">
                                <div class="c-common-box-shadow c-radius3" style="padding: 15px; height: 100%;">
                                    <div style="display: flex; align-items: flex-start;">
                                        <div style="margin-right: 10px; font-size: 24px; color: #999;">
                                            <i :class="getFileIcon(file)" aria-hidden="true"></i>
                                        </div>
                                        <div style="flex: 1; min-width: 0;">
                                            <h5 style="margin: 0 0 5px 0; font-weight: 600; word-break: break-word;">{{ file.name }}</h5>
                                            <p style="margin: 0 0 3px 0; font-size: 12px; color: #888;">
                                                <i class="fa fa-user" aria-hidden="true"></i> {{ file.creator_name || 'Unknown' }}
                                            </p>
                                            <p style="margin: 0 0 8px 0; font-size: 12px; color: #888;">
                                                <i class="fa fa-calendar" aria-hidden="true"></i> {{ getDate(file.created_at) }}
                                            </p>
                                            <!-- Note preview (truncated) -->
                                            <p v-if="file.type === 'note' && file.content" style="margin: 0 0 8px 0; font-size: 13px; color: #555; font-style: italic;">
                                                {{ truncateContent(file.content) }}
                                            </p>
                                        </div>
                                    </div>
                                    <div style="border-top: 1px solid #eee; padding-top: 10px; margin-top: 5px;">
                                        <ul class="o-filter-area" style="margin: 0;">
                                            <li v-if="file.type !== 'note'">
                                                <a href="javascript: void(0)" @click="previewFile(file)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue" style="font-size: 12px;">
                                                    <i class="fa fa-eye" aria-hidden="true"></i> Preview
                                                </a>
                                            </li>
                                            <li v-if="file.type !== 'note'">
                                                <a href="javascript: void(0)" @click="promptDownload(file)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green" style="font-size: 12px;">
                                                    <i class="fa fa-download" aria-hidden="true"></i> Download
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript: void(0)" @click="promptDelete(file)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon" style="font-size: 12px;">
                                                    <i class="fa fa-trash-o" aria-hidden="true"></i> Delete
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- Confidential Download Warning Modal -->
        <modal name="confidential-download-warning" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="cancelDownload()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Confidential Document Download</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 48px; color: #e6a23c; margin-bottom: 15px;"></i>
                                    <p style="font-size: 14px; line-height: 1.6;">
                                        You are downloading a confidential document from CallSteward.
                                        Once outside the platform, you are solely responsible for its handling,
                                        distribution, and security. This download will be logged for audit purposes.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="cancelDownload()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="confirmDownload()" class="c-solid-btn c-solid-btn--large c-solid-btn--green">
                                        <i class="fa fa-download" aria-hidden="true"></i> I Understand &mdash; Download
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <!-- Delete Confirmation Modal -->
        <modal name="confidential-delete-confirm" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="cancelDelete()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Delete Confidential File</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12 text-center">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 48px; color: #f56c6c; margin-bottom: 15px;"></i>
                                    <p style="font-size: 14px; line-height: 1.6;">
                                        Are you sure you want to permanently delete
                                        <strong>{{ fileToDelete ? fileToDelete.name : '' }}</strong>?
                                        This action cannot be undone.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="cancelDelete()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="confirmDelete()" class="c-solid-btn c-solid-btn--large" style="background-color: #f56c6c; border-color: #f56c6c; color: #fff;">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i> Delete
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    import { global } from '../../global.js';
    import service from '../../services.js';

    export default {
        props: {
            employerId: {
                type: String,
                required: true
            },
            clientId: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                files: [],
                loading: false,
                showAddNote: false,
                showUploadForm: false,
                newNote: {
                    name: '',
                    content: ''
                },
                selectedFile: null,
                uploadFileType: 'document',
                fileToDownload: null,
                fileToDelete: null,
            };
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
            }),

            canSeeConfidentialFiles() {
                const role = this.userRoleSlug;
                return ['client-admin', 'power-user'].includes(role);
            },

            apiBasePath() {
                return 'employer/' + this.employerId + '/confidential-files';
            },

            requestHeaders() {
                return {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.clientId || this.userClientID,
                };
            }
        },

        methods: {
            getDate(str) {
                return dateTimeConvert.localDate(str);
            },

            truncateContent(content) {
                if (!content) return '';
                return content.length > 100 ? content.substring(0, 100) + '...' : content;
            },

            getFileIcon(file) {
                if (file.type === 'note') return 'fa fa-sticky-note-o';
                if (file.type === 'audio') return 'fa fa-file-audio-o';
                if (file.type === 'video') return 'fa fa-file-video-o';
                if (file.type === 'photo') return 'fa fa-file-image-o';
                return 'fa fa-file-o';
            },

            fetchFiles() {
                if (!this.canSeeConfidentialFiles) return;
                this.loading = true;
                service.get(this.apiBasePath, this.requestHeaders)
                    .then((res) => {
                        this.files = res.data.result || res.data.data || [];
                        this.loading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false;
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Failed to load confidential files.'
                        });
                    });
            },

            // --- Add Note ---
            cancelAddNote() {
                this.showAddNote = false;
                this.newNote = { name: '', content: '' };
            },

            saveNote() {
                if (!this.newNote.name || !this.newNote.content) {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please provide both a name and content for the note.'
                    });
                    return;
                }
                service.post(this.apiBasePath, {
                    type: 'note',
                    name: this.newNote.name,
                    content: this.newNote.content,
                }, this.requestHeaders)
                    .then(() => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Confidential note added successfully.',
                            type: 'success'
                        });
                        this.cancelAddNote();
                        this.fetchFiles();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Failed to add confidential note.'
                        });
                    });
            },

            // --- Upload File ---
            onFileSelected(event) {
                var files = event.target.files;
                if (files && files.length > 0) {
                    this.selectedFile = files[0];
                } else {
                    this.selectedFile = null;
                }
            },

            cancelUpload() {
                this.showUploadForm = false;
                this.selectedFile = null;
                this.uploadFileType = 'document';
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
            },

            uploadFile() {
                if (!this.selectedFile) {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: 'Please select a file to upload.'
                    });
                    return;
                }
                var formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('type', this.uploadFileType);

                service.post(this.apiBasePath, formData, Object.assign({}, this.requestHeaders, {
                    'Content-Type': 'multipart/form-data'
                }))
                    .then(() => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Confidential file uploaded successfully.',
                            type: 'success'
                        });
                        this.cancelUpload();
                        this.fetchFiles();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Failed to upload confidential file.'
                        });
                    });
            },

            // --- Preview ---
            previewFile(file) {
                var url = global[0].BASE_URL + this.apiBasePath + '/' + file.id + '/preview';
                window.open(url, '_blank');
            },

            // --- Download with warning ---
            promptDownload(file) {
                this.fileToDownload = file;
                this.$modal.show('confidential-download-warning');
            },

            cancelDownload() {
                this.fileToDownload = null;
                this.$modal.hide('confidential-download-warning');
            },

            confirmDownload() {
                if (!this.fileToDownload) return;
                var file = this.fileToDownload;
                this.$modal.hide('confidential-download-warning');

                service.get(this.apiBasePath + '/' + file.id + '/download', Object.assign({}, this.requestHeaders, {
                    'X-CS-Confidential-Ack': 'true'
                }))
                    .then((res) => {
                        // If the response contains a download URL, open it
                        if (res.data && res.data.result && res.data.result.url) {
                            window.open(res.data.result.url, '_blank');
                        } else {
                            // Fallback: construct the download URL directly
                            var url = global[0].BASE_URL + this.apiBasePath + '/' + file.id + '/download';
                            window.open(url, '_blank');
                        }
                        this.fileToDownload = null;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Failed to download confidential file.'
                        });
                        this.fileToDownload = null;
                    });
            },

            // --- Delete ---
            promptDelete(file) {
                this.fileToDelete = file;
                this.$modal.show('confidential-delete-confirm');
            },

            cancelDelete() {
                this.fileToDelete = null;
                this.$modal.hide('confidential-delete-confirm');
            },

            confirmDelete() {
                if (!this.fileToDelete) return;
                var file = this.fileToDelete;
                this.$modal.hide('confidential-delete-confirm');

                service.del(this.apiBasePath + '/' + file.id, this.requestHeaders)
                    .then(() => {
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Confidential file deleted successfully.',
                            type: 'success'
                        });
                        this.fileToDelete = null;
                        this.fetchFiles();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Failed to delete confidential file.'
                        });
                        this.fileToDelete = null;
                    });
            },
        },

        mounted() {
            if (this.canSeeConfidentialFiles) {
                this.fetchFiles();
            }
        }
    };
</script>

<style scoped>
    .employer-confidential-files .o-filter-area {
        list-style: none;
        padding: 0;
        margin: 0;
        display: inline-block;
    }
    .employer-confidential-files .o-filter-area li {
        display: inline-block;
        margin-right: 5px;
        margin-bottom: 5px;
    }
    .employer-confidential-files .isDisabled {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
